module.exports = __webpack_public_path__ + "static/img_nodata-078101f90ff65ead4c43b40ba5246e7c.png";